import { css, Theme } from '@emotion/react'
import { paginationItemClasses } from '@mui/material'
import { COURSE_COLORS, CourseName } from 'theme/utils'

export const container = (theme: Theme) => css`
  height: 100%;
  width: 100%;
  padding: ${theme.spacing(3)};
`

export const tableTitle = (theme: Theme) => css`
  display: block;
  margin-top: ${theme.spacing(2)};
  text-align: left;
  font-weight: 700;
`

export const tableWrapper = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
  width: 100%;
`

export const table = (theme: Theme) => css`
  width: 100%;
  row-gap: 0;

  .table-header {
    padding: ${theme.spacing(2.25, 0)};
    background-color: transparent;

    .table-cell {
      font-weight: 600;
      color: ${theme.colors.typographyTwo};
    }
  }

  .table-row {
    min-height: 60px;
    padding: ${theme.spacing(2.25, 0)};
    border: none;
    border-radius: 0;
    box-shadow: none;

    :not(:first-of-type) {
      border-top: 1px solid #e6eaef;

      .table-cell {
        color: ${theme.colors.typographyThree};
      }
    }
  }

  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }

  .table-cell {
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
  }
`

export const practiceTestNameCell = (theme: Theme) => css`
  color: ${theme.colors.typographyTwo};
`
export const topic = (courseName: CourseName) => (theme: Theme) =>
  css`
    display: inline-flex;
    background-color: ${COURSE_COLORS[courseName].light};

    padding: ${theme.spacing(0.25, 1)};
    border-radius: 31px;

    color: ${COURSE_COLORS[courseName].main};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  `

const paginationItem = css`
  width: 48px;
  height: 48px;
  margin: 0 5px;
  border-radius: 14px;

  font-size: 16px;
  font-weight: 700;
  line-height: normal;
`

export const pagination = (theme: Theme) => css`
  justify-content: center;
  display: flex;

  margin-top: ${theme.spacing(2.75)};

  .${paginationItemClasses.page} {
    ${paginationItem};
    box-shadow: 0px 2px 2px -1px rgba(138, 148, 166, 0.13);
    border: 1px solid ${theme.colors.backgroundOne};
    color: ${theme.colors.typographyThree};

    &.${paginationItemClasses.selected} {
      color: ${theme.colors.blue};
      background-color: transparent;
    }
  }
  .${paginationItemClasses.previousNext} {
    ${paginationItem};
    background-color: ${theme.colors.blue};
    color: ${theme.colors.white};

    &.${paginationItemClasses.disabled} {
      background-color: transparent;
      border: 1px solid ${theme.colors.backgroundOne};
      box-shadow: 0px 2px 2px -1px rgba(138, 148, 166, 0.13);

      color: ${theme.colors.typographyThree};
    }
  }
`
